import React from "react";
import ReactDOM from "react-dom/client";
import { HelmetProvider } from "react-helmet-async";
import "@/index.css";
import App from "@/App";
import { initSentry } from "@/sentry";

// Initialize Sentry before any other code runs — zero-cost no-op if DSN unset.
initSentry();

const root = ReactDOM.createRoot(document.getElementById("root"));
root.render(
  <React.StrictMode>
    <HelmetProvider>
      <App />
    </HelmetProvider>
  </React.StrictMode>,
);

// Register the PWA service worker (powers offline cache + web-push handler).
// Production-only by default — dev mode can opt in via REACT_APP_SW_DEV=1.
if (
  "serviceWorker" in navigator &&
  (process.env.NODE_ENV === "production" || process.env.REACT_APP_SW_DEV === "1")
) {
  window.addEventListener("load", () => {
    navigator.serviceWorker
      .register("/sw.js")
      .catch((err) => console.warn("SW register failed:", err));
  });
}
